import { Database03 } from "untitledui-js-base";

export const NoData = () => {
  return (
    <div className="flex h-full grow flex-col items-center justify-center gap-6">
      <div className="flex h-[100px] w-[100px] items-center justify-center rounded-full bg-[#1C1D2205]">
        <Database03 className="stroke-content-400" size="40" />
      </div>
      <div className="flex flex-col gap-2 text-center">
        <p className="font-bold text-content-500">No data available</p>
        <p className="text-sm font-medium text-content-300">
          No data available at the moment
        </p>
      </div>
    </div>
  );
};
